<template>
  <div>
    <div class="row">
      <file-uploader
        upload-text="Upload Sound"
        reset-text="Reset Uploading"
        :accept-types="['.mp3']"
        :size-limit-m-b="sizeLimitMB"
        @uploaded="handleUploading"
        @reset="resetUploading"
      />
    </div>
    <div class="row">
      <span>Max size is {{ sizeLimitMB }} MB</span>
    </div>
  </div>
</template>

<script>
import FileUploader from "@/components/media/editing/FileUploader.vue";

// @group Editing
// Sound upload button
export default {
  name: "AudioUploader",
  components: {
    FileUploader
  },
  props: {
    // Max sound duration in seconds
    maxDuration: {
      type: Number,
      required: true
    },
    // Max uploading file size in MB
    sizeLimitMB: {
      type: Number,
      default: 5
    }
  },
  methods: {
    // @vuese
    // Create sound object from file and check result duration
    // @arg file - Sound MP3 file
    handleUploading({ file, approve }) {
      const url = URL.createObjectURL(file);
      const sound = new Audio();
      sound.src = url;

      // Update file when it uploaded with metadata
      sound.ondurationchange = () => {
        // Check that sound duration less or equal than limit
        if (sound.duration <= this.maxDuration) {
          // File uploaded
          this.$emit("fileUploaded", file);
          // Sound created
          this.$emit("upload", sound);
          // Upprove uploading
          approve();
        } else {
          this.$alert(
            "Audio must have duration equal or less than video.",
            "Error"
          );
        }
      };
    },
    // @vuese
    // Cancel uploading
    resetUploading() {
      this.$emit("upload", null);
      // File removed
      this.$emit("resetUploading");
    }
  }
};
</script>

<style scoped>
.row {
  display: flex;
  justify-content: center;
}
.row:not(:first-child) {
  margin-top: 10px;
}
</style>
